import { functionsBase } from '../config/functionsBase';

const FUNCTIONS_BASE = functionsBase(
  process.env.NODE_ENV === 'production'
    ? '/.netlify/functions'
    : 'http://localhost:8891/.netlify/functions'
);

export async function fetchPlayerAccount(discordId) {
  const response = await fetch(`${FUNCTIONS_BASE}/get-player-account`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discordId }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Erro ao carregar conta (${response.status})`);
  }
  return data;
}

export async function createPortalSession(discordId) {
  const response = await fetch(`${FUNCTIONS_BASE}/create-portal-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discordId }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Erro ao abrir portal (${response.status})`);
  }
  if (!data.url) {
    throw new Error('URL do portal não retornada');
  }
  return data;
}
